export default "/048cb1f2b29308e18768c65cfd51e426596a830c/c5d6534f4f2cb925009575e748220704.svg";